jQuery(document).ready(function($){
    $(document).foundation();
    $('[data-dropdown-options]').dropdownOptions();
});
